<template>
  <div class="vcl-accordion" @click.stop="$emit('click')">
    <div ref="header" class="vcl-accordion__header">
      <slot name="header" :toggle="toggle" :visible="visible" />
    </div>
    <transition
      :css="animation"
      name="accordion"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end"
    >
      <div v-show="visible" class="vcl-accordion__content">
        <slot name="content" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'VpAccordion',
  inject: {
    AccordionGroup: {
      default: null,
    },
  },
  props: {
    override: {
      type: Object,
      default: () => ({
        header: null,
        content: null,
        animation: null,
      }),
      required: false,
    }
  },
  data() {
    return {
      index: null,
      accordion: {
        count: 0,
        active: null,
      },
      animation: true,
    };
  },
  computed: {
    visible() {
      return this.index === this.accordion.active;
    },
  },
  watch: {
    override: {
      handler() {
        this.applyOverride();
      },
      deep: true,
    },
  },
  created() {
    if (this.AccordionGroup) {
      this.accordion = this.AccordionGroup;
    }
    this.index = this.accordion.count++;
  },
  mounted() {
    this.applyOverride();
  },
  methods: {
    toggle(e) {
      e.stopPropagation();
      if (this.visible) {
        this.accordion.active = null;
      } else {
        this.accordion.active = this.index;
      }
    },
    start(element) {
      const el = element;
      el.style.height = `${el.scrollHeight}px`;
    },
    end(element) {
      const el = element;
      el.style.height = '';
    },
    applyOverride() {
      if (this.override) {
        switch (this.override.header) {
          case 'hide':
            this.$refs.header.style.display = 'none';
            break;
          case 'show':
            this.$refs.header.style.display = 'block';
            break;
          default:
            break;
        }
        switch (this.override.content) {
          case 'open':
            this.accordion.active = this.index;
            break;
          case 'close':
            this.accordion.active = null;
            break;
          default:
            break;
        }
        switch (this.override.animation) {
          case false:
            this.animation = false;
            break;
          case true:
          default:
            this.animation = true;
            break;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.vcl-accordion {
  $self: &;
  &__header {
    margin: 0;
    padding: 0;
  }
  &__content {
    margin: 0;
    padding: 0;
  }
}
.accordion-enter-active, .accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity .3s ease;
  overflow: hidden;
}
.accordion-enter, .accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}

</style>
